import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getLanguage, getQueryString } from 'utils/params';
import { useTranslation } from 'react-i18next';
import { getOverviewHousingMaterials } from '../../aboutIsn.api';
import useFullPageLoader from '../../../commons/isn/useFullPageLoader';

const MaterialOverviewContent = () => {
  const language = getLanguage(useLocation());
  const { t } = useTranslation();
  const [overview, setOverview] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  useEffect(() => {
    showLoader();
    getOverviewHousingMaterials(getQueryString({ language })).then(res => {
      setOverview(res ?? []);
      hideLoader();
    });
    //eslint-disable-next-line
  }, []);

  // const gotoProductDetail = (id) => {
  //   history.push(`/${language}/about-us/housing-material/products/${id}`)
  // }

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  return (
    <>
      <div id="housingMaterialOverview">
        {overview && overview.length
          ? overview.map((item, index) => (
            <div className="overview-block row" key={index}>
              <div className={`${index === 0 || index % 2 === 0 ? '' : 'offset-lg-6'} col-lg-6 col-12`}>

                <div className="overview-image">
                  <img
                    src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                    className="w-100 h-100"
                    alt={item.title}
                  />
                </div>
              </div>
              <div className={`${index === 0 || index % 2 === 0 ? 'offset-lg-6' : ''} col-lg-6 col-12`}>
                <div className="overview-content">
                  <div className="overview-content-title">{item.title}</div>
                  <hr className="overview-content-line" />
                  <div className="overview-content-description" dangerouslySetInnerHTML={createMarkup(item?.content)}></div>
                  <div className="overview-content-description" dangerouslySetInnerHTML={createMarkup(item?.address)}></div>
                  <a className="goto-website" href={item?.website}>{item?.website}</a>
                  {item.showPdf === true ?
                    <div className="click-here">
                      {t('about_isn.housing_material.text_click_here')}
                      <a href={item.pdf}>{t('about_isn.housing_material.please_click_here')}</a>
                    </div>
                    : ''}
                </div>
              </div>
            </div>
          ))
          : ''}
      </div>
      {loader}
    </>
  );
};

export default MaterialOverviewContent;
